const PIXEL_ID = "5813996348666675";

export const initMetaPixel = () => {
  if (typeof window === "undefined" || window.fbq) return;

  /* eslint-disable */
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
};

export const trackEvent = (event, params) => {
  if (typeof window === "undefined" || !window.fbq) return;
  if (params) window.fbq("track", event, params);
  else window.fbq("track", event);
};

export const trackCustomEvent = (event, params) => {
  if (typeof window === "undefined" || !window.fbq) return;
  if (params) window.fbq("trackCustom", event, params);
  else window.fbq("trackCustom", event);
};

export const trackLead = (params) => trackEvent("Lead", params);

const ACTIVE_USER_KEY = "metaPixelActiveUser";

export const trackActiveUser = (params) => {
  try {
    if (sessionStorage.getItem(ACTIVE_USER_KEY)) return;
    sessionStorage.setItem(ACTIVE_USER_KEY, "1");
  } catch {}
  trackCustomEvent("ActiveUser", params);
};
